export const users = {
  reset: {
    error:
      "This action cannot be performed right now. The target user’s account is unchanged. Please try again later. If this persists, please raise <a>an Account Issue ticket</a> in our service desk.",
    password: {
      action: "Reset password",
      info: "Resets the User’s password by sending them an email with a link to reset their password. <br/><br/> Note: this action has no effect if the user logs-in via SSO. <br/><br/> Please see <docsLink>this page in our help documentation</docsLink> for troubleshooting and remediating log-in issues.",
      warning:
        "This link is <b>only valid for 1 hour</b>, therefore coordinate a recovery time with the target user accordingly. If the 1 hour window is missed, they will be locked out of their account until this password reset action is performed again.",
    },
    mfa: {
      action: "Reset MFA",
      info: "Resets the User’s Multi-factor authenticator (Okta Verify, Google Authenticator or both). They will be prompted to reset their MFA again when they next log in. <br/><br/> Please see <docsLink>this page in our help documentation</docsLink> for troubleshooting and remediating log-in issues.",
    },
  },
  deactivate: "Deactivate",
  resend: "Resend",
  After_confirmation_this_invitation_will_be_deleted_and_user_lose_access:
    "After confirmation, this invitation will be deleted and user lose access.",
  After_confirmation_this_person_will_be_deactivate_and_lose_access:
    "After confirmation, this person will be deactivate and lose access.",
  Are_you_sure_you_want_to_deactivate: "Are you sure you want to deactivate?",
  Are_you_sure_you_want_to_delete_invitation: "Are you sure you want to delete invitation?",
  Assign_roles: "Assign roles",
  Create_another_user: "Create another user",
  Edit_User: "Edit User",
  Email: "Email",
  activate: "Activate",
  First_Name: "First Name",
  Here_you_will_manage_companys_users: "Here you will manage company's users",
  Invite_New_User: "Invite New User",
  Invite_New_Users: "Invite New Users",
  Job_Title: "Job Title",
  Roles: "Roles",
  Status: "Status",
  Surname: "Surname",
  Update_user: "Update user",
  Use_this_window_to_setup_a_new_user:
    "Use this window to invite a new user. A user can have multiple roles except for the ‘Verifier’ role.",
  Users: "Users",
  users_management: "users management",
  no_users_added_yet: "You haven’t added any user yet.",
  status_options: {
    invited: "Invited",
    invitation_expired: "Invitation expired",
    active: "Active",
    deactivated: "Deactivated",
  },
} as const;
